
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >

    <div class="glass-names contenudesk contenuipad">
     
      <template v-for="(glass_item, index) in glasses">
        <div class="glass-name all"  v-if="glass_item.active && glass_item.id==glass.id">{{ glass_item.name }}</div>
        <div class="glass-name"  @click="$router.push({name:'editGlass', params: { id: glass_item.id }})" v-else-if="glass_item.active">{{ glass_item.name }}</div>
        
      </template>
    </div>


    <b-row class="row-big">
      
      <div :class="{'col-md-7':window.innerWidth > 768 && window.innerWidth <= 1024,'col-md-6':window.innerWidth <= 768 || window.innerWidth > 1024}">
        
        <b-card :title="glass.name" class="grey-col" >
          <a v-if="language=='fr'" :href="calculateGlassUrl()" target="_blank" class="custom-link">Personnaliser</a>
          <a v-else :href="calculateGlassUrl()" target="_blank" class="custom-link">Customize</a>
          
          <GlassRenders :glass="glass" />

            <!-- <div class="customfit-bottom" v-if="editingGlass">
              <div class="customfit">
                Tailles Uniques <img src='@/assets/images/cadenas1.svg' class="lock" />
              </div>
              <div class="customfit disabled">
                Sur-mesure <img src='@/assets/images/cadenas2.svg' class="lock" />
              </div>
            </div> -->
        </b-card>
      </div>
      
      <b-card :class="{withButtons:editingGlass}" :title="language=='fr' ? 'Informations générales' : 'Global information'" class="col-md-6 mb-1" v-if="window.innerWidth<=760 || window.innerWidth>1024">
        <div class="round-element right clickable" :class="{grey:editingGlass==false,gray:editingGlass==true}" @click="editingGlass=!editingGlass">
            <img src='@/assets/images/edit2.svg' class="icon" width="70" />
          </div>
          <div class="round-element black">
            <img src='@/assets/images/doc.svg' class="icon" width="70" />
          </div>
        <br />
        <div class="contenumob"><br /><br /></div>
        <validation-observer ref="simpleRules">
       <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="10"
           
            class="mb-1"
          >
            <b-form-group
              :label="language=='fr' ? 'Nom du produit' : 'Product name'"
              :class="{'form-group-plaintext':currentSuggest}"
              label-for="basicInput"
            >
            <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
                id="basicInput"
                v-model="form.name"
                 @focus="currentSuggest ? editingGlass=false : editingGlass=true"
             
                :placeholder="language=='fr' ? 'Nom du produit' : 'Product name'"
                :plaintext="currentSuggest==true"

                :state="errors.length > 0 ? false:null"
              />
              
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <img class="pending-icon" v-if="currentSuggest" src='@/assets/images/sablier2.svg' width="20" />
            <div  v-if="currentSuggest" class="current-suggest-popup">
              <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
            </div> 
          </b-form-group>

           <b-form-group
              :label="language=='fr' ? 'Matière' : 'Material'"
              :class="{'form-group-plaintext':currentSuggest}"
              label-for="basicInput"
            >
          
              <b-form-input
                id="basicInput"
                v-model="form.material"
                 @focus="currentSuggest ? editingGlass=false : editingGlass=true"
                
                :placeholder="language=='fr' ? 'Matière' : 'Material'"
                :plaintext="currentSuggest==true"

              />
              
       
            <img class="pending-icon" v-if="currentSuggest" src='@/assets/images/sablier2.svg' width="20" />
            <div  v-if="currentSuggest" class="current-suggest-popup">
              <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
            </div> 
          </b-form-group>

           <b-form-group
              :label="language=='fr' ? 'Fabrication' : 'Manufacturing'"
              :class="{'form-group-plaintext':currentSuggest}"
              label-for="basicInput"
            >
          
              <b-form-input
                id="basicInput"
                v-model="form.manufacturing"
                 @focus="currentSuggest ? editingGlass=false : editingGlass=true"
             
                :placeholder="language=='fr' ? 'Fabrication' : 'Manufacturing'"
                :plaintext="currentSuggest==true"

              />
              
       
            <img class="pending-icon" v-if="currentSuggest" src='@/assets/images/sablier2.svg' width="20" />
            <div  v-if="currentSuggest" class="current-suggest-popup">
              <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
            </div> 
          </b-form-group>

            <!-- <br />
            <b-form-group
              label="Nom de marque"
              label-for="basicInput"
            >
           
              <b-form-input
                id="basicInput"
                v-model="form.brand_name"
                :plaintext="readOnly"
                placeholder="Nom de la marque"
               
              />
             
            </b-form-group>
            -->
          

          </b-col>

          <b-col
            md="2"

            class="mb-1 price-top"
          >
          
          {{ glass.price+20 }}€                                                                                                                                                                                                                                                           

          </b-col>
        
        </b-row>
        <!-- <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Prix"
              label-for="Prix"
            >
            <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
                id="Prix"
                v-model="form.price"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Prix"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

      

         
        </b-row> -->
        <b-row>
          <b-col
            md="12"
            xl="12"
            class="mb-1"
            :class="{'form-group-plaintext':currentSuggest}"
          >
            <b-form-group>
         
            <label v-if="language=='fr'" for="textarea-default">Description du produit</label>
            <label v-else for="textarea-default">Product description</label>
            <b-form-textarea
             @focus="currentSuggest ? editingGlass=false : editingGlass=true"
            
              v-model="form.description"
              id="textarea-default"
              :placeholder="language=='fr' ? 'Description produit' : 'Product description'"
              :maxlength="500"
              :plaintext="currentSuggest==true"
              rows="3"
            />
            <div class="text-muted">
              {{ form.description.length }}/500 <template v-if="language=='fr'">caractères</template><template v-else>characters</template>
            </div>
            <img class="pending-icon" src='@/assets/images/sablier2.svg' v-if="currentSuggest" width="20" />
            <div  v-if="currentSuggest" class="current-suggest-popup">
               <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
            </div> 
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" xl="12" class="mb-1">
            
            <label v-if="language=='fr'" for="gallery-upload">Gallerie Photos</label>
            <label v-else for="gallery-upload">Photo Gallery</label>
            
            <div  v-if="currentSuggest" class="text-muted mt-2"  >
              
                <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
                <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
             <img class="pending-icon" v-if="currentSuggest" src='@/assets/images/sablier2.svg' width="20" />
             
            </div>
            <template v-else>

            <!-- Zone d'upload multiple -->
            <div class="gallery-upload-zone" :class="{'uploading': uploadingPhotos}">
              <b-form-file
                id="gallery-upload"
                v-model="selectedFiles"
                multiple
                accept="image/*,video/*"
                :placeholder="language=='fr' ? 'Choisissez ou glissez vos photos ici...' : 'Choose or drag your photos here...'"
                :drop-placeholder="language=='fr' ? 'Déposez vos photos ici...' : 'Drop your photos here...'"
                @change="handleMultipleFileUpload"
                :disabled="uploadingPhotos"
              />
              
              <div v-if="uploadingPhotos" class="upload-progress">
                <b-spinner small type="grow" variant="primary"></b-spinner>
                <span v-if="language=='fr'">Téléchargement en cours...</span>
                <span v-else>Uploading...</span>
              </div>
            </div>
            </template>

            <!-- Galerie des photos uploadées -->
            <div v-if="galleryPhotos.length > 0" class="gallery-grid">
              <div 
                v-for="(photo, index) in galleryPhotos" 
                :key="index" 
                class="gallery-item"
              >
                <img :src="photo.url || photo.base64" :alt="`Photo ${index + 1}`" />
                <div v-if="!currentSuggest" class="gallery-item-overlay">
                  <b-button 
                    variant="danger" 
                    size="sm" 
                    @click="removePhoto(index)"
                    class="remove-photo-btn"
                  >
                    <feather-icon icon="XIcon" size="14" />
                  </b-button>
                </div>
              </div>
            </div>

            <!-- Informations sur les limites -->
            <div class="text-muted mt-2" v-if="!currentSuggest" >
              <template v-if="language=='fr'">
                Formats acceptés : JPG, JPEG, PNG, MP4, MOV, AVI, WEBM. Taille max : 5MB par photo. 
                {{ galleryPhotos.length }} photo(s) ajoutée(s).
              </template>
              <template v-else>
                Accepted formats: JPG, JPEG, PNG, MP4, MOV, AVI, WEBM. Max size: 5MB per photo. 
                {{ galleryPhotos.length }} photo(s) added.
              </template>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" xl="12" class="mb-1">
            
            <label v-if="language=='fr'" for="big-photo-upload">Bio photo / vidéo</label>
            <label v-else for="big-photo-upload">Bio photo / video</label>
            
            <div v-if="currentSuggest" class="text-muted mt-2">
              <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
              <img class="pending-icon" v-if="currentSuggest" src='@/assets/images/sablier2.svg' width="20" />
            </div>
            
            <template v-else>
              <!-- Zone d'upload pour bio_photo -->
              <div class="big-photo-upload-zone" :class="{'uploading': uploadingBioPhoto}">
                <b-form-file
                  id="bio-photo-upload"
                  v-model="bioPhotoFile"
                  accept="image/*,video/*"
                  :placeholder="language=='fr' ? 'Choisissez une photo ou une vidéo...' : 'Choose a photo or a video...'"
                  :drop-placeholder="language=='fr' ? 'Déposez votre fichier ici...' : 'Drop your file here...'"
                  @change="handleBioPhotoUpload"
                  :disabled="uploadingBioPhoto"
                />
                
                <div v-if="uploadingBioPhoto" class="upload-progress">
                  <b-spinner small type="grow" variant="primary"></b-spinner>
                  <span v-if="language=='fr'">Téléchargement en cours...</span>
                  <span v-else>Uploading...</span>
                </div>
              </div>

              <!-- Prévisualisation du fichier uploadé -->
              <div v-if="bioPhotoPreview" class="big-photo-preview">
                <div class="preview-container">
                  <!-- Prévisualisation image -->
                  <img 
                    v-if="bioPhotoPreview.type === 'image'"
                    :src="bioPhotoPreview.url || bioPhotoPreview.base64" 
                    alt="Bio Photo Preview"
                    class="preview-image"
                  />
                  
                  <!-- Prévisualisation vidéo -->
                  <video
                    v-else-if="bioPhotoPreview.type === 'video'"
                    :src="bioPhotoPreview.url || bioPhotoPreview.base64"
                    controls
                    class="preview-video"
                  >
                    Votre navigateur ne supporte pas la lecture vidéo.
                  </video>
                  
                  <div class="preview-overlay">
                    <b-button 
                      variant="danger" 
                      size="sm" 
                      @click="removeBioPhoto"
                      class="remove-big-photo-btn"
                    >
                      <feather-icon icon="XIcon" size="14" />
                    </b-button>
                  </div>
                </div>
                
                <div class="file-info">
                  <small class="text-muted">
                    {{ bioPhotoPreview.name }} - {{ formatFileSize(bioPhotoPreview.size) }}
                  </small>
                </div>
              </div>

              <!-- Informations sur les limites -->
              <div class="text-muted mt-2">
                <template v-if="language=='fr'">
                  Formats acceptés : JPG, JPEG, PNG, MP4, MOV, AVI, WEBM. Taille max : 50MB.
                </template>
                <template v-else>
                  Accepted formats: JPG, JPEG, PNG, MP4, MOV, AVI, WEBM. Max size: 50MB.
                </template>
              </div>
            </template>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" xl="12" class="mb-1">
            
            <label v-if="language=='fr'" for="big-photo-upload">Photo/Vidéo Principale</label>
            <label v-else for="big-photo-upload">Main Photo/Video</label>
            
            <div v-if="currentSuggest" class="text-muted mt-2">
              <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
              <img class="pending-icon" v-if="currentSuggest" src='@/assets/images/sablier2.svg' width="20" />
            </div>
            
            <template v-else>
              <!-- Zone d'upload pour big_photo -->
              <div class="big-photo-upload-zone" :class="{'uploading': uploadingBigPhoto}">
                <b-form-file
                  id="big-photo-upload"
                  v-model="bigPhotoFile"
                  accept="image/*,video/*"
                  :placeholder="language=='fr' ? 'Choisissez une photo ou vidéo principale...' : 'Choose a main photo or video...'"
                  :drop-placeholder="language=='fr' ? 'Déposez votre fichier ici...' : 'Drop your file here...'"
                  @change="handleBigPhotoUpload"
                  :disabled="uploadingBigPhoto"
                />
                
                <div v-if="uploadingBigPhoto" class="upload-progress">
                  <b-spinner small type="grow" variant="primary"></b-spinner>
                  <span v-if="language=='fr'">Téléchargement en cours...</span>
                  <span v-else>Uploading...</span>
                </div>
              </div>

              <!-- Prévisualisation du fichier uploadé -->
              <div v-if="bigPhotoPreview" class="big-photo-preview">
                <div class="preview-container">
                  <!-- Prévisualisation image -->
                  <img 
                    v-if="bigPhotoPreview.type === 'image'" 
                    :src="bigPhotoPreview.url || bigPhotoPreview.base64" 
                    alt="Big Photo Preview"
                    class="preview-image"
                  />
                  
                  <!-- Prévisualisation vidéo -->
                  <video 
                    v-else-if="bigPhotoPreview.type === 'video'" 
                    :src="bigPhotoPreview.url || bigPhotoPreview.base64" 
                    controls
                    class="preview-video"
                  >
                    Votre navigateur ne supporte pas la lecture vidéo.
                  </video>
                  
                  <div class="preview-overlay">
                    <b-button 
                      variant="danger" 
                      size="sm" 
                      @click="removeBigPhoto"
                      class="remove-big-photo-btn"
                    >
                      <feather-icon icon="XIcon" size="14" />
                    </b-button>
                  </div>
                </div>
                
                <div class="file-info">
                  <small class="text-muted">
                    {{ bigPhotoPreview.name }} - {{ formatFileSize(bigPhotoPreview.size) }}
                  </small>
                </div>
              </div>

              <!-- Informations sur les limites -->
              <div class="text-muted mt-2">
                <template v-if="language=='fr'">
                  Formats acceptés : JPG, JPEG, PNG, MP4, MOV, AVI, WEBM. Taille max : 5MB.
                </template>
                <template v-else>
                  Accepted formats: JPG, JPEG, PNG, MP4, MOV, AVI, WEBM. Max size: 5MB.
                </template>
              </div>
            </template>
          </b-col>
        </b-row>
            
      </b-form>

    </validation-observer>

    <div class="sizes">
      <div class="label" v-if="language=='fr'">Tailles disponibles</div>
      <div class="label" v-else>Available sizes</div>
      <div class="available-sizes">
        <div class="size active" v-if="language=='fr'">Tailles standards</div>
        <div class="size active" v-else>One size</div>

        <div v-if="glass.custom_fit!=true" class="size disabled"><span v-if="language=='fr'" class="txt">Sur-mesure</span><span v-else class="txt">Custom-fit</span> <img src='@/assets/images/cadenas2.svg' class="lock" /><div class="popup-size"><template v-if="language=='fr'">Votre modèle ne dispose pas de sur-mesure</template><template v-else>Your model doesn't have custom-fit</template></div></div>
        <div v-else class="size active"><span v-if="language=='fr'" class="txt">Sur-mesure</span><span v-else class="txt">Custom-fit</span> <img src='@/assets/images/cadenas1.svg' class="lock" /></div>
        
      </div>
    </div>
    <div class="buttons-bottom" v-if="editingGlass">
        <b-button 
        variant="outline-primary"
      @click="cancelEditing()"
      >
      <template v-if="language=='fr'">Annuler</template>
      <template v-else>Cancel</template>
      </b-button>

      <b-button 
      @click.prevent="updateGlass"
      >
      <template v-if="language=='fr'">Valider</template>
      <template v-else>Confirm</template>
      
      </b-button>
    </div>

  </b-card>

      <div class="col-md-5"  v-else>
       
       <b-card :title="language=='fr' ? 'Nombre de visites' : 'Number of visits'" class="card-nb">
         <div class="round-element blue">
           <img src='@/assets/images/edit.svg' class="icon edit-blue" width="70" />
         </div>
           <b-dropdown pill variant="outline-secondary" class="top-button top-right-views" :text="currentViewsFilter.text">
            <b-dropdown-item v-if="currentViewsFilter.value!='week' && language=='fr'" @click="selectViewsFilter('week','Cette semaine')">Cette semaine</b-dropdown-item>
            <b-dropdown-item v-else-if="currentViewsFilter.value!='week' && language=='en'" @click="selectViewsFilter('week','This week')">This week</b-dropdown-item>
            <b-dropdown-item v-if="currentViewsFilter.value!='month' && language=='fr'" @click="selectViewsFilter('month','Ce mois')">Ce mois</b-dropdown-item>
            <b-dropdown-item v-else-if="currentViewsFilter.value!='month' && language=='en'" @click="selectViewsFilter('month','This month')">This month</b-dropdown-item>
            <b-dropdown-item v-if="currentViewsFilter.value!='year' && language=='fr'" @click="selectViewsFilter('year','Cette année')">Cette année</b-dropdown-item>
            <b-dropdown-item v-else-if="currentViewsFilter.value!='year' && language=='en'" @click="selectViewsFilter('year','This year')">This year</b-dropdown-item>
            <b-dropdown-item v-if="currentViewsFilter.value!='all' && language=='fr'" @click="selectViewsFilter('all','Tout')">Tout</b-dropdown-item>
            <b-dropdown-item v-else-if="currentViewsFilter.value!='all' && language=='en'" @click="selectViewsFilter('all','All')">All</b-dropdown-item>
          </b-dropdown>
         <div class="card-nb-col col-nb">

          <div v-if="loadingViews" class="d-flex justify-content-center align-items-center" style="height: 80px;">
            <b-spinner small type="grow" variant="primary"></b-spinner>
          </div>
          <h2 v-else class="big-nb">
            <span class="sign">
              <img src='@/assets/images/edit.svg' class="icon" width="70" />
            </span>
            {{ views_count }}
          </h2>
         </div>
         </b-card>
     </div>

    </b-row>

    <b-row class="row-align">
      <div class="col-md-4"  v-if="window.innerWidth<=760 || window.innerWidth>1024">
       
        <b-card :title="language=='fr' ? 'Nombre de visites' : 'Number of visits'" class="card-nb">
          <div class="round-element blue">
            <img src='@/assets/images/edit.svg' class="icon edit-blue" width="70" />
          </div>
            <b-dropdown pill variant="outline-secondary" class="top-button top-right-views" :text="currentViewsFilter.text">
              <b-dropdown-item v-if="currentViewsFilter.value!='week' && language=='fr'" @click="selectViewsFilter('week','Cette semaine')">Cette semaine</b-dropdown-item>
              <b-dropdown-item v-else-if="currentViewsFilter.value!='week' && language=='en'" @click="selectViewsFilter('week','This week')">This week</b-dropdown-item>
              <b-dropdown-item v-if="currentViewsFilter.value!='month' && language=='fr'" @click="selectViewsFilter('month','Ce mois')">Ce mois</b-dropdown-item>
              <b-dropdown-item v-else-if="currentViewsFilter.value!='month' && language=='en'" @click="selectViewsFilter('month','This month')">This month</b-dropdown-item>
              <b-dropdown-item v-if="currentViewsFilter.value!='year' && language=='fr'" @click="selectViewsFilter('year','Cette année')">Cette année</b-dropdown-item>
              <b-dropdown-item v-else-if="currentViewsFilter.value!='year' && language=='en'" @click="selectViewsFilter('year','This year')">This year</b-dropdown-item>
              <b-dropdown-item v-if="currentViewsFilter.value!='all' && language=='fr'" @click="selectViewsFilter('all','Tout')">Tout</b-dropdown-item>
              <b-dropdown-item v-else-if="currentViewsFilter.value!='all' && language=='en'" @click="selectViewsFilter('all','All')">All</b-dropdown-item>
            </b-dropdown>
          <div class="card-nb-col col-nb">

            <div v-if="loadingViews" class="d-flex justify-content-center align-items-center" style="height: 80px;">
              <b-spinner small type="grow" variant="primary"></b-spinner>
            </div>
            <h2 v-else class="big-nb">
              <span class="sign">
                <img src='@/assets/images/edit.svg' class="icon" width="70" />
              </span>
              {{ views_count }}
            </h2>
          </div>
          </b-card>
      </div>


      <b-card :title="language=='fr' ? 'Informations générales' : 'Globla informations'" class="col-md-12 mb-1" v-if="window.innerWidth>760 && window.innerWidth<1024">
        <div class="round-element right clickable" :class="{grey:editingGlass==false,gray:editingGlass==true}" @click="editingGlass=!editingGlass">
            <img src='@/assets/images/edit2.svg' class="icon" width="70" />
          </div>
          <div class="round-element black">
            <img src='@/assets/images/doc.svg' class="icon" width="70" />
          </div>
        <br />
        <div class="contenumob"><br /><br /></div>
        <validation-observer ref="simpleRules">
       <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="10"
           
            class="mb-1"
          >
            <b-form-group
              :label="language=='fr' ? 'Nom du produit' : 'Product name'"
              :class="{'form-group-plaintext':currentSuggest}"
              label-for="basicInput"
            >
            <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
                id="basicInput"
                v-model="form.name"
                @input="editingGlass=true"
                :placeholder="language=='fr' ? 'Nom du produit' : 'Product name'"
                :plaintext="currentSuggest==true"

                :state="errors.length > 0 ? false:null"
              />
              
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            <img class="pending-icon" v-if="currentSuggest" src='@/assets/images/sablier2.svg' width="20" />
            <div  v-if="currentSuggest" class="current-suggest-popup">
              <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
            </div> 
          </b-form-group>
            <!-- <br />
            <b-form-group
              label="Nom de marque"
              label-for="basicInput"
            >
           
              <b-form-input
                id="basicInput"
                v-model="form.brand_name"
                :plaintext="readOnly"
                placeholder="Nom de la marque"
               
              />
             
            </b-form-group>
            -->
          

          </b-col>

          <b-col
            md="2"

            class="mb-1 price-top"
          >
          
          {{ glass.price+20 }}€                                                                                                                                                                                                                                                           

          </b-col>
        
        </b-row>
        <!-- <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Prix"
              label-for="Prix"
            >
            <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
                id="Prix"
                v-model="form.price"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                placeholder="Prix"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>

      

         
        </b-row> -->
        <b-row>
          <b-col
            md="12"
            xl="12"
            class="mb-1"
            :class="{'form-group-plaintext':currentSuggest}"
          >
         
            <label v-if="language=='fr'" for="textarea-default">Description du produit</label>
            <label v-else for="textarea-default">Product description</label>
            <b-form-textarea
            @input="editingGlass=true"
              v-model="form.description"
              id="textarea-default"
              :placeholder="language=='fr' ? 'Description produit' : 'Product description'"
              :plaintext="currentSuggest==true"
              rows="3"
            />
            <img class="pending-icon" src='@/assets/images/sablier2.svg' v-if="currentSuggest" width="20" />
            <div  v-if="currentSuggest" class="current-suggest-popup">
              <template v-if="language=='fr'">Votre modification est en cours de validation. Vous recevrez un email de confirmation sous peu.</template>
              <template v-else>Your edit is pending validation. You will receive an email confirmation soon.</template>
            </div> 
          </b-col>
        </b-row>
        
            
      </b-form>

    </validation-observer>

    <div class="sizes">
      <div class="label" v-if="language=='fr'">Tailles disponibles</div>
      <div class="label" v-else>Available sizes</div>
      <div class="available-sizes">
        <div class="size active" v-if="language=='fr'">Tailles standards</div>
        <div class="size active" v-else>One size</div>

        <div v-if="glass.custom_fit!=true" class="size disabled"><span v-if="language=='fr'" class="txt">Sur-mesure</span><span v-else class="txt">Custom-fit</span> <img src='@/assets/images/cadenas2.svg' class="lock" /><div class="popup-size">Votre modèle ne dispose pas de sur-mesure</div></div>
        <div v-else class="size active"><span v-if="language=='fr'" class="txt">Sur-mesure</span><span v-else class="txt">Custom-fit</span> <img src='@/assets/images/cadenas1.svg' class="lock" /></div>
        
      </div>
    </div>

    

<div class="buttons-bottom" v-if="editingGlass">
      <b-button 
      variant="outline-primary"
    @click="cancelEditing()"
    >
    <template v-if="language=='fr'">Annuler</template>
    <template v-else>Cancel</template>
    </b-button>

    <b-button 
    @click.stop="updateGlass()"
    >
     <template v-if="language=='fr'">Valider</template>
    <template v-else>Confirm</template>
    
    </b-button>
  </div>

  
        

      </b-card>

     
        <b-card  :class="{'col-md-12':window.innerWidth > 768 && window.innerWidth <= 1024,'col-md-8':window.innerWidth <= 768 || window.innerWidth > 1024}" :title="language=='fr' ? 'Montant généré' : 'Generated amount'" class="card-nb">
         
        
          <div class="round-element green">
            <img src='@/assets/images/stats.svg' class="icon" width="70" />
          </div>

          <b-dropdown pill variant="outline-secondary" class="top-button top-right right" :text="currentDateFilter.text">
            <b-dropdown-item v-if="currentDateFilter.value!='week' && language=='fr'" @click="selectDateFilter('week','Cette semaine')">Cette semaine</b-dropdown-item>
            <b-dropdown-item v-else-if="currentDateFilter.value!='week' && language=='en'" @click="selectDateFilter('week','This week')">This week</b-dropdown-item>
            <!-- <b-dropdown-item v-if="currentDateFilter.value!='month'" @click="selectDateFilter('month','This month')">This month</b-dropdown-item> -->
            <b-dropdown-item v-if="currentDateFilter.value!='year' && language=='fr'" @click="selectDateFilter('year','Cette année')">Cette année</b-dropdown-item>
            <b-dropdown-item v-else-if="currentDateFilter.value!='year' && language=='en'" @click="selectDateFilter('year','This year')">This year</b-dropdown-item>
          </b-dropdown>


          <b-row>
            <div class="col-md-6 col-nb">
              <h2 class="big-nb contenudesk"><span class="sign">€</span> {{totalFiltered.toLocaleString()}} </h2>

            </div>
            <div class="col-md-6 green">
              <div v-if="comissions.length==0"><br /><br /><template v-if="language=='fr'">Aucune vente pour ce produit.</template><template v-else>No sell for this product.</template></div>
              <VueApexCharts v-else-if="graphLoading==false" height="150" :options="chartOptions" :series="series"></VueApexCharts>
              <h2 class="big-nb contenumob"><span class="sign">€</span> {{totalFiltered.toLocaleString()}} </h2>
            </div>
          </b-row>          
         
       

        </b-card>
     
    </b-row>

  
  <b-modal
          id="modal-danger"
          cancel-variant="outline-secondary"
          :cancel-title="language=='fr' ? 'Non' : 'No'"
          ok-variant="danger"
          :ok-title="language=='fr' ? 'Oui' : 'Yes'"
          @ok="deleteModelPart(selectedItem)"
          modal-class="modal-danger"
          centered
          :title="language=='fr' ? 'Êtes-vous sûr ?' : 'Are you sure ?'"
        >
          <b-card-text v-if="language=='fr'">

            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer ce model part ?
          </b-card-text>
          <b-card-text v-else>
            Warning, this action is irreversible! Are you sure you want to delete this model part?

          </b-card-text>
        </b-modal>
  
  
      </b-overlay>

 

</template>

<script>
import { BButton,BFormInput, BDropdown,BDropdownItem,BRow, BForm, BCol,BOverlay, BFormGroup,BFormFile, BCard, BCardText, BMedia, BImg, BFormCheckbox, BFormTextarea, BSpinner} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import RenderGlass from './RenderGlass.vue'
import GlassRenders from './GlassRenders.vue'
import {APIRequest,Utils,Auth} from '@simb2s/senseye-sdk'
import Ripple from 'vue-ripple-directive'
import draggable from 'vuedraggable'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import VueApexCharts from 'vue-apexcharts'
import format from 'date-fns/format'
import { languages } from 'prismjs'
export default {
  name: 'GlassForm',
  components: {
    BButton,
    BDropdownItem,
    RenderGlass,
    GlassRenders,
    VueApexCharts,
    BDropdown,
    BCardText,
    BMedia, 
    BOverlay,
    BImg,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    BSpinner,
    draggable,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  directives: {
    Ripple,
  },
  
  data() {
      return {
      currentSuggestManufacturing:false,
      currentSuggestMaterial:false,
      bigPhoto: null, // Pour stocker le fichier big_photo
      bioPhoto: null, // Pour stocker le fichier bio_photo
      bioPhotoPreview: null, // Pour la prévisualisation
      bigPhotoPreview: null, // Pour la prévisualisation
      uploadingBigPhoto: false, // État de chargement
      uploadingBioPhoto: false, // État de chargement
      bigPhotoFile: null, // Fichier sélectionné
      bioPhotoFile: null, // Fichier sélectionné
      maxBigPhotoSize: 50 * 1024 * 1024, // 50MB pour photos/vidéos
      maxBioPhotoSize: 50 * 1024 * 1024, // 50MB pour photos/vidéos
      acceptedBioPhotoFormats: ['image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'video/mov', 'video/avi', 'video/webm'],
      acceptedBigPhotoFormats: ['image/jpeg', 'image/jpg', 'image/png', 'video/mp4', 'video/mov', 'video/avi', 'video/webm'],
      currentSuggestGallery:false,
         galleryPhotos: [], // Pour stocker les photos de la galerie
      uploadingPhotos: false, // État de chargement pour l'upload
      maxFileSize: 5 * 1024 * 1024, // 5MB par fichier
      acceptedFormats: ['image/jpeg', 'image/jpg', 'image/png','video/mp4', 'video/mov', 'video/avi', 'video/webm'],
       selectedFiles: null,
        currentViewsFilter: {
          text: this.language=='fr' ? 'Ce mois' : 'This month',
          value: 'month'
        },
        window:window,
        loadingViews:false,
        edit_suggests:null,
        currentSuggest:false,
        glasses:[],
        totalFiltered:0,
        totalComission:0,
        comissions:[],
        editingGlass:false,
        currentDateFilter:{text:this.language=='fr' ? 'Cette semaine' : 'This week',value:'week'},
        views_count:0,
        date_begin:null, 
        dateFormatAPI: 'YYYY-MM-DD',
        dateFormat: 'D MMM YYYY',
        dateOne: this.getDateInit(),
        dateTwo: new Date() ,
        date_end:new Date(),
        filteredViewsCount: 0,
        allViewsData: [],
        series: [{
          name: this.language=='fr' ? 'Montant généré' : 'Generated amount',
          data: [2.3, 3.1, 4.0, 10.1, 4.0, 3.6, 3.2]
        }],
        chartOptions: {
          chart: {
            
            type: 'bar',
            toolbar: {
              show: false,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false
                
              },
            },
          },
          tooltip: {
            enabled: false, // Désactive la bulle au survol
          },
          states: {
            hover: {
                filter: {
                    type: 'none',
                }
            },
            active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                    type: 'none',
                }
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 3,
              dataLabels: {
                position: 'top', // top, center, bottom
              },
              colors: {
                ranges: [{
                  from: 0,
                  to: 100000,
                  color: '#E3E3E3'
                }],
                  
              },
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              return val + "€";
            },
            offsetY: -20,
            style: {
              fontWeight: 'normal',
              fontSize: '12px',
              colors: ["#000"]
            }
          },
              
          xaxis: {
            categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            position: 'bottom',
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false
            },
            
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            axisBorder: {
              show: false
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
             
            }
          
          },
          grid: {
            show: false,
            borderColor: '#ffffff',
            strokeDashArray: 0,
            position: 'back',
            xaxis: {
              lines: {
                show: false
              }
            },
            yaxis: {
              lines: {
                show: false
              }
            }
          }
            
        },

        photoDatas:[],
           
        selectedItem:null,
          loading:true,
          
          initialForm:{
            name:"",
           manufacturing:"",
           material:"",
           brand_name:"",
           description:'',
           price:0,
          },
         
          form:{
            name:"",
            manufacturing:"",
            material:"",
            brand_name:"",
            description:'',
            price:0,
            
          },
          graphLoading:true,
         
      }
  },
  computed: {
   
  },
  filters: {
      
  },
  
  watch:{
     
  },
 
  props: [
    'language',
    'glass', 
    'readOnly', 
    'glass_textures',
    'glass_colors',
    'glass_tints',
    'glass_branchs',
    'glass_glass_options',
    'glass_glass_types',
    'glass_refinements',
    'glass_processings',
    'glass_photos'
    ],
  methods:{
    calculateGlassUrl()
    {
      if(this.glass.id==59)
      {
        return 'https://visages.com/clara-berry/sasha'
      }
      else if(this.glass.id==64)
      {
        return 'https://visages.com/clara-berry/hair-pin'
      }
      else if(this.glass.id!=25 && this.glass.id!=26 && this.glass.id!=27 && this.glass.id!=28)
      {
        return 'https://visages.com/collection-new/'+this.glass.id
      }
      else
      {
        return 'https://visages.com/collection/'+this.glass.id
      }
    },

     async handleBigPhotoUpload(event) {
      console.log('handleBigPhotoUpload')
      const file = event.target.files[0];
      if (!file) return;

      this.uploadingBigPhoto = true;

      try {
        // Vérification du type de fichier
        if (!this.acceptedBigPhotoFormats.includes(file.type)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.language=='fr' ? `${file.name} n'est pas un format valide` : `${file.name} is not a valid format`,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        // Vérification de la taille
        if (file.size > this.maxBigPhotoSize) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.language=='fr' ? `${file.name} est trop volumineux (max 50MB)` : `${file.name} is too large (max 50MB)`,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        // Déterminer le type de fichier
        const fileType = file.type.startsWith('video/') ? 'video' : 'image';
        
        // Conversion en base64 pour prévisualisation
        const base64 = await this.fileToBase64(file);
        
        this.bigPhotoPreview = {
          name: file.name,
          base64: base64,
          file: file,
          url: null,
          type: fileType,
          size: file.size
        };

        // Marquer comme modifié
        this.editingGlass = true;

      } catch (error) {
        console.error('Erreur lors de l\'upload:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.language=='fr' ? 'Erreur lors de l\'upload' : 'Upload error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.uploadingBigPhoto = false;
        // Réinitialiser l'input
        event.target.value = '';
      }
    },

    async handleBioPhotoUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.uploadingBioPhoto = true;

      try {
        // Vérification du type de fichier
        if (!this.acceptedBioPhotoFormats.includes(file.type)) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.language=='fr' ? `${file.name} n'est pas un format valide` : `${file.name} is not a valid format`,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        // Vérification de la taille
        if (file.size > this.maxBioPhotoSize) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.language=='fr' ? `${file.name} est trop volumineux (max 50MB)` : `${file.name} is too large (max 50MB)`,
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          });
          return;
        }

        // Déterminer le type de fichier
        const fileType = file.type.startsWith('video/') ? 'video' : 'image';
        
        // Conversion en base64 pour prévisualisation
        const base64 = await this.fileToBase64(file);
        
        this.bioPhotoPreview = {
          name: file.name,
          base64: base64,
          file: file,
          url: null,
          type: fileType,
          size: file.size
        };

        // Marquer comme modifié
        this.editingGlass = true;

      } catch (error) {
        console.error('Erreur lors de l\'upload:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.language=='fr' ? 'Erreur lors de l\'upload' : 'Upload error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.uploadingBioPhoto = false;
        // Réinitialiser l'input
        event.target.value = '';
      }
    },

    removeBioPhoto() {
      this.bioPhotoPreview = null;
      this.bioPhotoFile = null;
      this.editingGlass = true;
    },

    removeBigPhoto() {
      this.bigPhotoPreview = null;
      this.bigPhotoFile = null;
      this.editingGlass = true;
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // Méthode pour uploader le big_photo sur le serveur
    async uploadBigPhoto() {
      if (!this.bigPhotoPreview || !this.bigPhotoPreview.file) {
        return this.bigPhotoPreview?.url || null;
      }

      try {
        const formData = new FormData();
        formData.append('big_photo', this.bigPhotoPreview.file);
        formData.append('glass_id', this.glass.id);

        // Upload via votre API (adaptez selon votre backend)
        const response = await APIRequest.upload('glass-big-photo', formData);
        
        return response.url;
      } catch (error) {
        console.error('Erreur upload big photo:', error);
        return null;
      }
    },
    async uploadBioPhoto() {
      if (!this.bioPhotoPreview || !this.bioPhotoPreview.file) {
        return this.bioPhotoPreview?.url || null;
      }

      try {
        const formData = new FormData();
        formData.append('bio_photo', this.bioPhotoPreview.file);
        formData.append('glass_id', this.glass.id);

        // Upload via votre API (adaptez selon votre backend)
        const response = await APIRequest.upload('glass-big-photo', formData);
        
        return response.url;
      } catch (error) {
        console.error('Erreur upload bio photo:', error);
        return null;
      }
    },
    async handleMultipleFileUpload(event) {
      const files = event.target.files;
      if (!files || files.length === 0) return;

      this.uploadingPhotos = true;

      try {
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          
          // Vérification du type de fichier
          if (!this.acceptedFormats.includes(file.type)) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.language=='fr' ? `${file.name} n'est pas un format valide` : `${file.name} is not a valid format`,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            });
            continue;
          }

          // Vérification de la taille
          if (file.size > this.maxFileSize) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.language=='fr' ? `${file.name} est trop volumineux` : `${file.name} is too large`,
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            });
            continue;
          }

          // Conversion en base64 pour prévisualisation
          const base64 = await this.fileToBase64(file);
          
          this.galleryPhotos.push({
            name: file.name,
            base64: base64,
            file: file,
            url: null // sera rempli après upload sur le serveur
          });
        }

        // Réinitialiser l'input file
        this.selectedFiles = null;
        event.target.value = '';

      } catch (error) {
        console.error('Erreur lors de l\'upload:', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.language=='fr' ? 'Erreur lors de l\'upload' : 'Upload error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.uploadingPhotos = false;
      }
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    removePhoto(index) {
      this.galleryPhotos.splice(index, 1);
      this.editingGlass = true; // Marquer comme modifié
    },

    // Méthode pour uploader les photos sur le serveur (à appeler lors de la sauvegarde)
    async uploadGalleryPhotos() {
      const uploadedPhotos = [];

      for (const photo of this.galleryPhotos) {
        if (photo.file && !photo.url) {
          try {
            // Créer un FormData pour l'upload
            const formData = new FormData();
            formData.append('photo', photo.file);
            formData.append('glass_id', this.glass.id);

            // Upload via votre API (adaptez selon votre backend)
            const response = await APIRequest.upload('glass-photos', formData);
            
            uploadedPhotos.push({
              id: response.id,
              url: response.url,
              name: photo.name
            });
          } catch (error) {
            console.error('Erreur upload photo:', error);
          }
        } else if (photo.url) {
          // Photo déjà uploadée
          uploadedPhotos.push(photo);
        }
      }

      return uploadedPhotos;
    },
    async filterViewsByDate() {
      this.loadingViews=true
      let date_end = new Date();
      let date_begin;
      
      if (this.currentViewsFilter.value === 'week') {
        date_begin = new Date();
        date_begin.setDate(date_begin.getDate() - 7);
      } else if (this.currentViewsFilter.value === 'month') {
        date_begin = new Date();
        date_begin.setMonth(date_begin.getMonth() - 1);
      } else if (this.currentViewsFilter.value === 'year') {
        date_begin = new Date();
        date_begin.setFullYear(date_begin.getFullYear() - 1);
      } else if (this.currentViewsFilter.value === 'all') {
        // Pour "tout", on récupère depuis le début
        date_begin = new Date(2020, 0, 1); // Depuis 2020 par exemple
      }
      
      // Appeler l'API avec les dates spécifiées
      let datebegin = format(date_begin, this.dateFormatAPI);
      let dateend = format(date_end, this.dateFormatAPI);
      let stats = await APIRequest.get_stats(this.glass.id, datebegin, dateend);
      this.filteredViewsCount = stats.data;
      this.views_count=stats.data
      this.loadingViews=false
    },
    selectViewsFilter(value, text) {
      this.currentViewsFilter.text = text;
      this.currentViewsFilter.value = value;
      this.filterViewsByDate();
    },
    cancelEditing()
    {
      this.form=this.initialForm
      this.editingGlass=false
    },
    selectDateFilter(value,text)
    {
      this.currentDateFilter.text=text
      this.currentDateFilter.value=value

      this.filterComissionsByDate()
    },
    filterComissionsByDate(){
      this.graphLoading=true
      this.totalFiltered=0
      let date_end=new Date()
      let date_begin
      if(this.currentDateFilter.value=='week')
      {
        let date = new Date()
        date.setDate(date.getDate() - 7)
        date_begin = date

        // Calculate all days of the week until today and put them in a table
        var daysOfWeek = []
        var valuesOfWeek = []
        for (let i = 0; i < 7; i++) {

          let tempDate = new Date(date_begin)
          tempDate.setDate(tempDate.getDate() + i)
          daysOfWeek.push(tempDate.toLocaleDateString('fr-FR', { weekday: 'short' }))
          valuesOfWeek.push(0)
        }
        
        this.chartOptions.xaxis.categories=daysOfWeek

        var datesOfWeek = []
        for (let i = 0; i < 7; i++) {
          let tempDate = new Date(date_begin)
          tempDate.setDate(tempDate.getDate() + i)
          datesOfWeek.push(tempDate.toLocaleDateString('us-US'))
        }

    
        
      

      }
      if(this.currentDateFilter.value=='month')
      {
        let date = new Date()
        date.setDate(date.getDate() - 30) 
        date_begin = date

        // Calculate all days of the month until today and put them in a table
        var daysOfMonth = []
        var valuesOfMonth = []
        for (let i = 0; i < 30; i++) {
          let tempDate = new Date(date_begin)
          tempDate.setDate(tempDate.getDate() + i)
          daysOfMonth.push(tempDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }))
          valuesOfMonth.push(0)
        }
        
        this.chartOptions.xaxis.categories = daysOfMonth

        var datesOfMonth = []
        for (let i = 0; i < 30; i++) {
          let tempDate = new Date(date_begin)
          tempDate.setDate(tempDate.getDate() + i)
          datesOfMonth.push(tempDate.toLocaleDateString('us-US'))
        }


      }
      if(this.currentDateFilter.value=='year')
      {
        let date = new Date()
        date.setDate(date.getDate() - 365) 
        date_begin = date

        // Calculate all months of the year until today and put them in a table
        var monthsOfYear = []
        var valuesOfYear = []
        for (let i = 0; i < 13; i++) {
          let tempDate = new Date(date_begin)
          tempDate.setMonth(tempDate.getMonth() + i)
          monthsOfYear.push(tempDate.toLocaleDateString('fr-FR', { month: 'short', year: '2-digit' }))
          valuesOfYear.push(0)
        }
        
        this.chartOptions.xaxis.categories = monthsOfYear

        var datesOfYear = []
        for (let i = 0; i < 13; i++) {
          let tempDate = new Date(date_begin)
          tempDate.setMonth(tempDate.getMonth() + i)
          datesOfYear.push(tempDate.toLocaleDateString('us-US'))
        }
      }


    
          
      for(let i=0;i<this.comissions.length;i++)
      {
        if(this.comissions[i].date!=null)
        {
        
          let [d, m, y] = this.comissions[i].date.split(/-|\//); // splits "26-02-2012" or "26/02/2012"
          let date = new Date(y, m - 1, d);
          

          // On verifie si c'est compris entre les deux dates



          if(date.getTime()>=date_begin.getTime() && date.getTime()<=date_end.getTime())
          {


            // Si oui on ajoute le total de la comission
        
            

            if(this.currentDateFilter.value=='week')
            {
              for(let j=0;j<daysOfWeek.length;j++)
              {
                if(date.toLocaleDateString('fr-FR', { weekday: 'short' })==daysOfWeek[j])
                {
                  valuesOfWeek[j]+=this.comissions[i].amount
                  this.totalFiltered+=this.comissions[i].amount
                }
              }
              
            }
            if(this.currentDateFilter.value=='month')
            {
              for(let j=0;j<daysOfMonth.length;j++)
              {
                if(date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })==daysOfMonth[j])
                {
                  valuesOfMonth[j]+=this.comissions[i].amount
                  this.totalFiltered+=this.comissions[i].amount
                }
              }
            }
            if(this.currentDateFilter.value=='year')
            {
              for(let j=0;j<monthsOfYear.length;j++)
              {
                if(date.toLocaleDateString('fr-FR', { month: 'short', year: '2-digit' })==monthsOfYear[j])
                {
                  valuesOfYear[j]+=this.comissions[i].amount
                  this.totalFiltered+=this.comissions[i].amount
                }
              }
            }
          }

        }
      }

      if(this.currentDateFilter.value=='week')
        {
          this.series[0].data=valuesOfWeek
        }
        if(this.currentDateFilter.value=='month')
        {
          this.series[0].data=valuesOfMonth
        }
        if(this.currentDateFilter.value=='year')
        {
          this.series[0].data=valuesOfYear
        }

        setTimeout(() => {
          this.graphLoading=false
        }, 10);
      //this.blackGraphLoading=false
    },
    formatDates(dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          formattedDates = format(dateOne, this.dateFormat)
        }
        if (dateTwo) {
          formattedDates += ' - ' + format(dateTwo, this.dateFormat)
        }

        
        return formattedDates
      },
    getDateInit()
      {
        let date = new Date()
        date.setDate(date.getDate() - 30) 
        return date
      },
    calculatePhoto(layer_info) {
            let hue = layer_info.presets.hue_app ? layer_info.presets.hue_app : 100
            let saturation = layer_info.presets.saturation ? layer_info.presets.saturation : 100
            let brightness = layer_info.presets.brightness ? layer_info.presets.brightness : 100


            let url
            if(brightness==100 && hue==100 && saturation==100)
            {
            url = 'https://api.sens-eye.fr/render_parts/'+layer_info.render
            }
            else {
            url = 'https://api.sens-eye.fr/api/photo-single-test?photo='+layer_info.render+'&hue='+hue+'&saturation='+saturation+'&brightness='+brightness
            }

            //this.$emit('calculatePhotoEv',0)

            return url
            

        },
        
        getOpacityElement(layer) {
          if(this.photoDatas[layer].presets.opacity != null) {
                return this.photoDatas[layer].presets.opacity/100
            }
            else {
                return 1
            }
        },
  async calculatePhotos(){
    let request = '?glass='+this.glass.id+'&branch=4'
    let model_parts_data=this.glass.model_parts
                
                for(let j=0;j<model_parts_data.length;j++) {
                
                    
                
                if(model_parts_data[j].render_type!="shadow" && model_parts_data[j].render_type!="hinge" && model_parts_data[j].render_type!="manchon"){
                    if(model_parts_data[j].type=='color') {
                        if(model_parts_data[j].render_slug=="frame" || model_parts_data[j].render_slug=="frame1")
                        {
                            if(model_parts_data[j].material=="plastic")
                            {
                                if(this.glass.default_color!=null && model_parts_data[j].render_slug!="frame1")
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                    if(this.glass.id==29)
                                    {
                                        request+='&color_'+model_parts_data[j].render_slug+'=6'
                                    }
                                    else
                                    {
                                        request+='&color_'+model_parts_data[j].render_slug+'=10'
                                    }
                                }
                               

                                
                                
                            }
                            else 
                            {
                                if(this.glass.default_color!=null && model_parts_data[j].render_slug!="frame1")
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=19'
                                }
                            }
                            request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else if(model_parts_data[j].render_slug=="temples")
                        {
                            if(model_parts_data[j].material=="plastic")
                            {
                                if(this.glass.default_color!=null)
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                    if(this.glass.id==29)
                                    {
                                        request+='&color_'+model_parts_data[j].render_slug+'=6'
                                    }
                                    else
                                    {
                                        if(model_parts_data[j].colors.length)
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'='+model_parts_data[j].colors[0].id
                                        }
                                        else
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'=10'
                                        }
                                    }
                                }
                               
                                
                            }
                            else {
                                if(model_parts_data[j].colors.length)
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'='+model_parts_data[j].colors[0].id
                                        }
                                        else
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'=20'
                                        }
                            }
                            request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else {
                        if(model_parts_data[j].material=="plastic")
                        {
                            request+='&color_'+model_parts_data[j].render_slug+'=10'
                           
                        }
                        else {
                            request+='&color_'+model_parts_data[j].render_slug+'=19'
                            
                        }
                        
                        }
                        request+='&texture_'+model_parts_data[j].render_slug+'=4'
                    
                    }
                    else if(model_parts_data[j].type=='texture_color') { 
                
                
                        if(model_parts_data[j].render_slug=="frame" || model_parts_data[j].render_slug=="frame1")
                        {

                            if(this.glass.default_color!=null && model_parts_data[j].render_slug!="frame1")
                            {
                                request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                            }
                            else
                            {

                                if(model_parts_data[j].material=="plastic")
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=10'
                                }
                                else 
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'=19'
                                }
                            }
                            
                            request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else if(model_parts_data[j].render_slug=="temples")
                        {
                
                        
                            if(model_parts_data[j].material=="plastic")
                            {
                                if(this.glass.default_color!=null)
                                {
                                    request+='&color_'+model_parts_data[j].render_slug+'='+this.glass.default_color.id
                                }
                                else
                                {
                                request+='&color_'+model_parts_data[j].render_slug+'=10'
                                }
                            }
                            else {
                                if(model_parts_data[j].colors.length)
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'='+model_parts_data[j].colors[0].id
                                        }
                                        else
                                        {
                                            request+='&color_'+model_parts_data[j].render_slug+'=20'
                                        }
                               
                            }
                        
                
                        request+='&texture_style_'+model_parts_data[j].render_slug+'=0'
                        }
                        else {
                        if(model_parts_data[j].material=="plastic")
                        {
                            request+='&color_'+model_parts_data[j].render_slug+'=10'
                        }
                        else {
                            request+='&color_'+model_parts_data[j].render_slug+'=19'
                        }
                        
                        }
                        
                        request+='&texture_'+model_parts_data[j].render_slug+'=4'
                
                    }
                    else if (model_parts_data[j].render_type=="lense")
                    {
                        // ici tint
                        let default_tint=4
                        if(this.selectedFilter=='optic')
                        {
                            default_tint=5
                        }
                        else 
                        {
                            if(this.glass.default_tint!=null)
                            {
                                default_tint=this.glass.default_tint.id
                            }
                               
                        }
                        request+='&tint_'+model_parts_data[j].render_slug+'='+default_tint
                        
                    }
                    
                    
                    
                    }
                    else if (model_parts_data[j].render_type=="manchon")
                    {
                        request+='&color_'+model_parts_data[j].render_slug+'=24'
                   
                    }
                }
                
                
                let render_infos =  await APIRequest.list_renders('photos-layers-new',request)
                let render_infos_datas=render_infos
                
                if(this.glass.id==26)
                {
                 
                    this.photoDatas=render_infos_datas.scene1
                }
                else {
                    
                    this.photoDatas=render_infos_datas.scene2
                }
  },

  async getEditSuggests(){
    let edits_suggest = await APIRequest.list('edit-suggests',null,null,1000)
    this.edit_suggests=edits_suggest[0]
    for(let i=0;i<this.edit_suggests.length;i++)
    {
      if(this.edit_suggests[i].glass.id==this.glass.id)
      {
        console.log('okk')
        this.currentSuggest=true
      }
    }
    

  },
     
      async updateGlass()
      {
         this.$refs.simpleRules.validate().then(async success => {
          if (success) {
         
          

          try {

            this.loading=true

             let bigPhotoUrl = null;
              if (this.bigPhotoPreview) {
                if (this.bigPhotoPreview.url) {
                  bigPhotoUrl = this.bigPhotoPreview.url;
                } else if (this.bigPhotoPreview.base64) {
                  bigPhotoUrl = this.bigPhotoPreview.base64;
                }
              }

              let bioPhotoUrl = null;
              if (this.bioPhotoPreview) {
                if (this.bioPhotoPreview.url) {
                  bioPhotoUrl = this.bioPhotoPreview.url;
                } else if (this.bioPhotoPreview.base64) {
                  bioPhotoUrl = this.bioPhotoPreview.base64;
                }
              }

          
            let gallery=[]
            for(let i=0;i<this.galleryPhotos.length;i++)
            {
              if(this.galleryPhotos[i].url)
              {
                gallery.push({photo:this.galleryPhotos[i].url})
              }
              else if(this.galleryPhotos[i].base64)
              {
                gallery.push({photo:this.galleryPhotos[i].base64})
              }
            }
            var datas={}
            datas.gallery_photos=JSON.stringify(gallery)
            datas.name=this.form.name
             datas.big_photo = bigPhotoUrl;
             datas.bio_photo = bioPhotoUrl;
            datas.price=this.form.price
            datas.brand_name=this.form.brand_name
            datas.description=this.form.description
            datas.material=this.form.material
            datas.manufacturing=this.form.manufacturing
            datas.status="pending"
            datas.glass={id:this.glass.id}
            datas.user={id:localStorage.id_user_senseye_auth}

            let edit_suggest = await APIRequest.create('edit-suggests',datas)
            
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'La suggestion a bien été envoyée !',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
            this.$router.push({name:'glasses'})
          } catch (error) {
            console.log("error")
            console.log(error)
            this.loading=false
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Une erreur est survenue.',
                icon: 'AlertCircleIcon',
                variant: 'warning',
              },
            })
            
          }
        }
         })
      },
      async getStats() {
        let datebegin=format(this.dateOne, this.dateFormatAPI)
        let dateend=format(this.dateTwo, this.dateFormatAPI)
        let stats=await APIRequest.get_stats(this.glass.id,datebegin,dateend)
        this.views_count=stats.data
        this.filteredViewsCount = stats.data;
      },
      async getComissions() {
        let comissions=await APIRequest.get_comissions_glass(this.glass.id)

        this.comissions=comissions.data
     
        this.totalComission=comissions.total
      }
      
      
  },
  async mounted(){

    let glasses 
        if(localStorage.id_user_senseye_auth==1189)
        {
          glasses=await APIRequest.list_with_request('glasses','?limit=1000&creator_owner='+localStorage.id_user_senseye_auth)
        }
        else 
        {
          glasses=await APIRequest.list_with_request('glasses','?active=1&limit=1000&creator_owner='+localStorage.id_user_senseye_auth)
        }
    this.glasses=glasses[0]
    if(this.glass!=null)
    {

      this.initialForm=this.glass
      this.form=this.glass

      if (this.glass.gallery_photos) {
        let gallery_array=JSON.parse(this.glass.gallery_photos)
        this.galleryPhotos = gallery_array.map((photo, index) => ({
          name: "Photo "+index,
          url: photo,
          base64: null,
          file: null
        }));
      }

      if (this.glass.bio_photo) {
        // Déterminer le type basé sur l'extension
        const isVideo = /\.(mp4|mov|avi|webm)$/i.test(this.glass.bio_photo);
        
        this.bioPhotoPreview = {
          name: "Bio Photo",
          url: this.glass.bio_photo,
          base64: null,
          file: null,
          type: isVideo ? 'video' : 'image',
          size: 0
        };
      }

      if (this.glass.big_photo) {
        // Déterminer le type basé sur l'extension
        const isVideo = /\.(mp4|mov|avi|webm)$/i.test(this.glass.big_photo);
        
        this.bigPhotoPreview = {
          name: "Big Photo/Video",
          url: this.glass.big_photo,
          base64: null,
          file: null,
          type: isVideo ? 'video' : 'image',
          size: 0
        };
      }

      this.edition=true

      await this.getStats()
      await this.getComissions()
      await this.filterComissionsByDate()
      
    }
    
    await this.calculatePhotos()
    await this.getEditSuggests()
    this.loaded=true
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.top-button.top-right-views
{
  right:70px;
}
label
{
  font-size: 12px !important;
  font-weight: 500 !important;
  color:#000000 !important;
}
.custom-link:hover
{
  background-color: #fff;
  color:#000;
}
.custom-link
{
  border: 1px solid #000000;
border-radius: 10px;
padding:8px 50px;
font-size:14px;
background-color: #000000;
display: block;
float:left;
transition: all 0.3s;
color:#fff;
position:absolute;
top:50px;

z-index:3;
}
.card-nb-col
{
  height:90%;
}
.withButtons 
{
  padding-bottom:50px !important;
}
.card-nb
{
  height:95%;
}
.price-top
{
  padding-top:33px;
  line-height: 1;
  white-space: nowrap;
}
.buttons-bottom button
{
  width:49%;
}
img.lock
{
  display:inline-block;
  width:10px !important;
}
.buttons-bottom
{
  position:absolute;
  left:5%;
  width:90%;
  bottom:20px;
  display:flex;
  justify-content:space-between;
}
.top-right 
{
  margin-right:80px;
}
.grey-col .img img
{
  top:50% !important;
  position: absolute !important;
  transform: translateY(-50%);
  width:100%;
  height:auto;
}
.grey-col .img .render-layer2
{
  position:absolute;
  width:100%;
  left:0;
  top:0;
  height:auto;
}
.top-right
{
  left:200px;
}

.customfit-bottom .customfit.disabled
{
 opacity:0.5;
}
.customfit-bottom .customfit
{
padding:0 10px;
margin-right:10px;
margin-left:10px;
}
.customfit-bottom
{
  position:absolute;
  bottom:20px;
  left:0;
  width:100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
.sizes {
  position:relative;
  display:flex;
  align-items:center;
}
.row-align
{
  align-items: stretch !important;
}
.sizes .size.disabled:hover .popup-size
{
  
  display:block;
}
.sizes .popup-size
{
  display:none;
  font-size: 13px;
  background:#fff;
  color: #000000;
  transform:translateY(90%);
  padding:20px;
  position:absolute;
  bottom:0;
  z-index: 2;
  border-radius: 10px;
  border:0.5px solid #707070;
  max-width:200px;
}
.pending-icon
{
  left:7px !important;
}
.sizes .label 
{
  padding-right:15px;
  font-weight: 500;
  font-size: 12px !important;
}
.size.disabled img,.size.disabled .txt
{
  opacity:0.5;
}

.size.active {
  font-weight: 600;
  background:#fff;
}
.text-muted
{
  font-size:13px;
}
.size {
  font-size:12px;
  
  border-radius:8px;
  padding:7px 15px;
}
.size:first-child
{
  margin-right:3px;
}
.available-sizes
{
  background-color:rgba(118,118,128,0.12);
  display:flex;
  padding:3px;
  border-radius: 8px;
}
@media screen and (max-width:768px)
{
  .col-md-10
  {
    width:75% !important;
  }
  .col-md-2
  {
    width:25% !important;
  }
  .buttons-bottom
  {
    position: relative;
    left:0;
    width:100%;
    bottom:auto;
    margin-top:20px;
  }
  .sizes .label
  {
    padding-right:5px !important;
  }
  .size
  {
    font-size:11px !important;
    padding: 5px 5px;
  }
  .img.lock
  {
    width:7px !important;
  }
}
@media screen and (min-width:768px) and (max-width:1024px)
{
 
  .buttons-bottom
  {
    position: relative;
    left:0;
    width:100%;
    bottom:auto;
    margin-top:20px;
  }
}
.gallery-upload-zone {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  margin-bottom: 20px;

  &:hover {
    border-color: #007bff;
    background-color: #f8f9fa;
  }

  &.uploading {
    pointer-events: none;
    opacity: 0.7;
  }
}

.upload-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.gallery-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .gallery-item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover .gallery-item-overlay {
    opacity: 1;
  }

  .remove-photo-btn {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.form-group
{
  position:relative;
}
@media screen and (max-width: 768px) {
  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
  }
}

.big-photo-upload-zone {
  border: 2px dashed #ddd;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  margin-bottom: 20px;

  &:hover {
    border-color: #007bff;
    background-color: #f8f9fa;
  }

  &.uploading {
    pointer-events: none;
    opacity: 0.7;
  }
}

.big-photo-preview {
  margin-top: 15px;
  
  .preview-container {
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #ddd;
    max-width: 400px;
    margin: 0 auto;

    .preview-image,
    .preview-video {
      width: 100%;
      height: auto;
      max-height: 300px;
      object-fit: cover;
    }

    .preview-overlay {
      position: absolute;
      top: 10px;
      right: 10px;
      
      .remove-big-photo-btn {
        border-radius: 50%;
        width: 32px;
        height: 32px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .file-info {
    text-align: center;
    margin-top: 10px;
  }
}

@media screen and (max-width: 768px) {
  .big-photo-preview .preview-container {
    max-width: 100%;
  }
}
</style>